import React, { useRef, useEffect } from 'react';
import { gsap, ScrollTrigger } from '@titelmedia/bricks-utils';
import {
  Wrapper,
  ContainerWrapper,
  ImageContainer,
  Image,
  ImageItem,
  WrapperOverlay,
  OverlayContainer,
} from './styles';
import { BREAKPOINTS } from '@titelmedia/bricks-theme/lib/variables/breakpoints';

export const Overlay = ({
  items,
  staticImage,
  staticPosition,
  overlayHorizontal,
  overlayVertical,
  overlayAlignment,
  enableAnimation,
  setAnimationDuration,
  customCss,
}) => {
  const wrapperRef = useRef(null);
  const imageContainer = useRef(null);
  const overlayRef = useRef(null);
  const fluid =
    staticImage?.fluid || staticImage?.responsiveImage || staticImage;
  overlayHorizontal = overlayHorizontal || 'center';
  overlayVertical = overlayVertical || 'bottom';
  const isAnimationEnable =
    enableAnimation === 'true' || enableAnimation === true;
  // 'true' string is for storybook.

  useEffect(() => {
    if (!wrapperRef.current || typeof window === 'undefined') return;
    const elements = overlayRef.current.querySelectorAll('img');
    const mm = gsap.matchMedia();

    if (mm) {
      mm.add(`(min-width: ${BREAKPOINTS.sm}px)`, () => {
        gsap.set(elements, {
          y: 100,
          opacity: 0,
        });
        gsap.to(wrapperRef.current, {
          scrollTrigger: {
            trigger: wrapperRef.current,
            start: 'top top',
            end: `+=${imageContainer.current.offsetHeight * 3}`,
            pin: true,
          },
        });
        ScrollTrigger.batch(elements, {
          trigger: wrapperRef.current,
          start: 'top top',
          end: `+=${imageContainer.current.offsetHeight * 2}`,
          batchMax: 1,
          onEnter: batch =>
            gsap.to(batch, {
              y: 0,
              opacity: 1,
              stagger: 0.5,
              delay: 1,
              overwrite: 'auto',
            }),
        });
      });
    }
    if (isAnimationEnable) {
      gsap.effects.fade(wrapperRef.current, {
        duration: setAnimationDuration ? setAnimationDuration : 0.75,
        trigger: wrapperRef.current,
      });
    }
  }, [isAnimationEnable, setAnimationDuration]);

  return (
    <Wrapper ref={wrapperRef} customCss={customCss}>
      <ContainerWrapper
        staticPosition={staticPosition}
        role="region"
        aria-label="Overlay Image Gallery"
      >
        {fluid && (
          <ImageContainer ref={imageContainer} aspectRatio={fluid.aspectRatio}>
            <Image src={fluid.src} />
          </ImageContainer>
        )}
        <WrapperOverlay
          overlayHorizontal={overlayHorizontal}
          overlayVertical={overlayVertical}
        >
          <OverlayContainer
            ref={overlayRef}
            overlayAlignment={overlayAlignment}
          >
            {items?.map((item, i) => {
              return (
                <ImageItem
                  key={`item-${i}`}
                  tabIndex={0}
                  src={item.src}
                  srcSet={item.srcSet}
                  alt={item.alt || `Gallery Image ${i + 1}`}
                  aspectRatio={item.aspectRatio}
                />
              );
            })}
          </OverlayContainer>
        </WrapperOverlay>
      </ContainerWrapper>
    </Wrapper>
  );
};
